export default __webpack_public_path__ + "static/media/pkt1.8a36c0da.svg";